import { toast } from "react-toastify";
import { getInvoicePdf } from "../Api/apiUtils";

export const getInvoiceId = (payment: any): string =>
  payment?.invoice_result?.invoice_id || payment?.invoice_id || "";

export const getInvoiceUrl = (payment: any): string =>
  payment?.invoice_result?.invoice_url || payment?.invoiceLink || payment?.invoice_url || "";

export const hasInvoice = (payment: any): boolean =>
  !!(getInvoiceId(payment) || getInvoiceUrl(payment));

// Fetches the invoice PDF by Zoho invoice_id (the stored invoice_url share link expires).
// Falls back to opening the stored link only when there's no invoice_id or the download fails.
export const downloadInvoice = async (payment: any) => {
  const invoiceId = getInvoiceId(payment);
  const invoiceUrl = getInvoiceUrl(payment);

  if (!invoiceId) {
    if (invoiceUrl) window.open(invoiceUrl, "_blank", "noopener,noreferrer");
    return;
  }

  try {
    const result = await getInvoicePdf(invoiceId);
    if (!result?.data) throw new Error("Empty invoice response");

    const binary = atob(result.data);
    const bytes = new Uint8Array(binary.length);
    for (let i = 0; i < binary.length; i++) bytes[i] = binary.charCodeAt(i);
    const blob = new Blob([bytes], { type: result.contentType || "application/pdf" });

    const invoiceNumber = payment?.invoice_result?.invoice_number;
    const fileName = invoiceNumber ? `${invoiceNumber}.pdf` : (result.fileName || `invoice_${invoiceId}.pdf`);

    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    setTimeout(() => URL.revokeObjectURL(link.href), 1000);
  } catch (error) {
    console.error("Invoice download failed", error);
    if (invoiceUrl) {
      toast.warn("Couldn't download the invoice PDF, opening the invoice link instead.");
      window.open(invoiceUrl, "_blank", "noopener,noreferrer");
    } else {
      toast.error("Failed to download invoice. Please try again.");
    }
  }
};
